<template>
  <div class="popup-edit">
    <el-form ref="form" :model="form" :rules="rules" label-width="120px" size="small">
      <div class="white-container">
        <el-form-item label="挑战赛类型" prop="type">
          <el-radio-group v-model="form.type" :disabled="disabledStatus">
            <el-radio :label="1">个人挑战赛</el-radio>
            <el-radio :label="2">好友PK赛</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="标题" prop="name" style="width: 424px">
          <el-input v-model="form.name" maxlength="14" placeholder="请输入任务标题，最多不超过14个字符" :disabled="disabledStatus" />
        </el-form-item>
        <el-form-item label="挑战内容" prop="content" style="width: 424px">
          <el-select v-model="form.content" placeholder="请选择挑战内容" :disabled="disabledStatus">
            <el-option v-for="item in content" :key="item.id" :label="item.name" :value="item.id" />
          </el-select>
        </el-form-item>
        <el-form-item label="挑战时长" prop="duration" style="width: 424px">
          <div class="flex">
            <el-input v-model.number="form.duration" :disabled="disabledStatus" oninput="value=value.replace(/[^0-9]/g,'')" style="width:86px;" />&nbsp;秒
          </div>
        </el-form-item>
        <el-form-item label="挑战赛介绍" prop="introduction" style="width: 744px">
          <el-input v-model="form.introduction" type="textarea" :autosize="{ minRows: 5, maxRows: 5}" placeholder="请输入挑战赛介绍" :disabled="disabledStatus" />
        </el-form-item>
        <el-form-item label="抽奖规则" prop="sweepstakesRules" style="width: 744px">
          <el-input v-model="form.sweepstakesRules" type="textarea" :autosize="{ minRows: 5, maxRows: 5}" placeholder="请输入抽奖规则" :disabled="disabledStatus" />
        </el-form-item>
        <el-form-item v-if="form.type === 2" label="可抽奖次数" prop="numberOfDraws" style="width: 304px">
          <el-select v-model="form.numberOfDraws" popper-class="_movingTarget_" placeholder="请选择可抽奖次数" :disabled="disabledStatus">
            <el-option v-for="(item,index) in movingSelectVO" :key="index" :label="item" :value="item" />
          </el-select>
        </el-form-item>
        <el-form-item label="奖品配置" prop="prizeInformationAddDTOList">
          <div :class="lottery?'lotteryDisabled':''" title="已开奖后无法修改" style="margin-left:-48px;margin-top:40px;font-family: 'Noto Sans SC'">
            <template v-for="(item, index) in form.prizeInformationAddDTOList">
              <div :key="index" style="margin:20px 0" :class="lottery?'lottery-context':''">
                <span style="margin-right: 10px">奖品{{ index + 1 }}</span>
                <el-input v-model="item.prizeName" placeholder="请输入奖品名称" style="width: 147px;margin:0 10px 0 0" :disabled="disabledStatus" />
                <el-input v-model="item.prizeNum" type="number" placeholder="请输入奖品数量" style="width: 147px;margin:0 10px 0 0" :disabled="disabledStatus" />
                <span class="delPrize" style="font-size: 14px;color: #0085D0;user-select: none;cursor: pointer;" @click="()=>{form.prizeInformationAddDTOList.splice(index, 1)}">删除</span>
              </div>
            </template>
          </div>
          <el-button v-if="!lottery" class="addPrize" @click="addPrizeItem">+ 新增奖品</el-button>
        </el-form-item>
      </div>

      <div class="white-container marginTop">
        <el-form-item label="上传弹窗图片" prop="matchImage" class="image-config">
          <div class="flex uploadImg-cont">
            <UploadImage :disabled="disabledStatus" :url="form.matchImage.listPictures" title="列表页图片" save-path="challengeMatch/" size-tips="686px*240px" @triggerReg="handleCheckReg" @upload="data => (form.matchImage.listPictures = data)" />
            <UploadImage :disabled="disabledStatus" :url="form.matchImage.matchDetailsPageHeader" title="挑战赛详情页头图" save-path="challengeMatch/" size-tips="750px*370px" @triggerReg="handleCheckReg" @upload="data => (form.matchImage.matchDetailsPageHeader = data)" />
            <UploadImage :disabled="disabledStatus" :url="form.matchImage.shareCardImage" title="小程序分享卡片" save-path="challengeMatch/" :limit-size="2" size-tips="500px*400px" @triggerReg="handleCheckReg" @upload="data => (form.matchImage.shareCardImage = data)" />
            <UploadImage :disabled="disabledStatus" :url="form.matchImage.shareImage" title="挑战赛长图分享图片" save-path="challengeMatch/" size-tips="676px*742px" @triggerReg="handleCheckReg" @upload="data => (form.matchImage.shareImage = data)" />
            <UploadImage v-if="form.type === 1" :disabled="disabledStatus" :url="form.matchImage.userRankingSharing" title="用户排名分享图片" save-path="challengeMatch/" size-tips="676px*742px" @triggerReg="handleCheckReg" @upload="data => (form.matchImage.userRankingSharing = data)" />
            <UploadImage :disabled="disabledStatus" :url="form.matchImage.myMatchListPictures" title="我的活动列表页图片" save-path="challengeMatch/" size-tips="162px*180px" @triggerReg="handleCheckReg" @upload="data => (form.matchImage.myMatchListPictures = data)" />
            <UploadImage v-if="form.type === 2" :disabled="disabledStatus" :url="form.matchImage.acceptTheInvitationPop" title="接受邀请弹窗" save-path="challengeMatch/" size-tips="622px*680px" @triggerReg="handleCheckReg" @upload="data => (form.matchImage.acceptTheInvitationPop = data)" />
          </div>
        </el-form-item>
        <el-form-item style="width: 100%; margin-top: 80px; margin-left: -50px">
          <div class="flex btns">
            <el-button type="info" @click="handleCancel">取消</el-button>
            <el-button type="primary" @click="submit">保存</el-button>
          </div>
        </el-form-item>
      </div>
    </el-form>
    <Dialog v-if="formDialogShow" v-model="formDialogShow" :information="information" @submit-success="dialogSuccess" />
  </div>
</template>
<script>
// import { mapActions, mapState } from 'vuex'
import { ChallengeMatch } from "@/model/ChallengeMatch";
import UploadImage from "@/components/UploadImage";
import Dialog from "@/components/Dialog";
const btnType = [{ id: 0, name: 'CTA' }, { id: 1, name: '返回' }];
const content = [
  { id: 0, name: "徒手深蹲" },
  { id: 1, name: "卷腹摸膝" },
];
export default {
  components: { UploadImage, Dialog },
  data() {
    return {
      btnType,
      content,
      formDialogShow: false,
      information: {},
      cancelTxt: "",
      form: new ChallengeMatch(),
      disabledStatus: false,
      lottery: false,
      movingSelectVO: [2, 4, 6, 8, 10, 12, 14, 16, 18, 20],
      rules: {
        type: [
          { required: true, message: "请输入挑战赛类型", trigger: ["change"] },
        ],
        name: [
          { required: true, message: "请输入任务标题", trigger: ["blur"] },
        ],
        content: [
          { required: true, message: "请选择挑战内容", trigger: ["blur", "change"] },
        ],
        duration: [
          { required: true, message: "请输入挑战时长", trigger: ["blur", "change"] },
        ],
        introduction: [
          { required: true, message: "请输入挑战赛介绍", trigger: ["blur", "change"] },
        ],
        matchImage: {
          required: true, validator: (rule, value, callback) => {
            const array = [];
            for (const key in value) {
              array.push(value[key]);
            }
            if (array.filter((item) => item !== '').length < 6) {
              callback(new Error('请上传图片'));
            } else {
              callback();
            }
          }, trigger: ['change'],
        },
      },
    };
  },
  watch: {
    "form.type": {
      deep: true,
      handler(newVal, oldVal) {
        this.$refs.form.clearValidate();
      },
    },
  },
  async created() {
    const { query } = this.$route;
    this.lottery = query.lottery == 'true';
    if (query.id) {
      this.form.id = query.id;
      this.cancelTxt = "编辑";
      await this.getDetails("edit");
    } else if (query.copyid) {
      this.form.id = query.copyid;
      this.cancelTxt = "复制";
      await this.getDetails("copy");
    } else {
      this.cancelTxt = "新增";
    }
  },
  methods: {

    handleCheckReg(val) {
      this.$refs.form.validateField("matchImage");
    },
    // 获弹窗详情
    async getDetails() {
      await this.$Api.challengeMatch.fetchChallengeMatch(this.form.id).then(res => {
        this.form = new ChallengeMatch(res);
      });
    },
    submit() {
      this.formDialogShow = true;
      this.information = {
        operation: "submit",
        icon: "warn",
        subTitle: "请注意挑战赛状态，保存后已发布的挑战赛将实时更新至UA HOUSE小程序",
      };
    },
    createChallengeMatch() {
      this.form.formatForm();
      this.$Api.challengeMatch.createChallengeMatch(this.form).then(() => {
        this.$message.success("保存成功");
        setTimeout(() => {
          this.$router.push('/online_activity/challengeMatch');
        }, 2000);
      });
    },
    // 更新接口
    updateChallengeMatch() {
      this.form.formatForm();
      this.$Api.challengeMatch.updateChallengeMatch(this.form).then(() => {
        this.$message.success("编辑成功");
        setTimeout(() => {
          this.$router.push('/online_activity/challengeMatch');
        }, 2000);
      });
    },

    // 取消
    handleCancel() {
      this.formDialogShow = true;
      this.information = {
        operation: "cancel",
        icon: "warn",
        subTitle: `是否放弃${this.cancelTxt}，返回上级页面？`,
      };
    },
    dialogSuccess() {
      if (this.information.operation && this.information.operation === 'cancel') {
        this.$router.go(-1);
      } else if (this.information.operation && this.information.operation === 'submit') {
        this.$refs.form.validate(valid => {
          if (valid) {
            if (this.form.id) {
              this.updateChallengeMatch();
            } else {
              this.createChallengeMatch();
            }
          } else {
            return false;
          }
        });
      }
    },
    // 新增奖品
    addPrizeItem() {
      this.form.prizeInformationAddDTOList.push({
        prizeLevel: 1,
        prizeName: "",
        prizeNum: null,
      });
    },
  },
};
</script>

<style lang="less" scoped>
.popup-edit {
  .btns {
    align-items: center;
    justify-content: center;
    .el-button {
      width: 120px;
      height: 50px;
    }
    .el-button.el-button {
      margin-right: 30px;
    }
  }
  /deep/ .btn-wrap {
    display: flex;
    width: 100%;
    height: 32px;
    margin-bottom: 30px;
    .type-select {
      width: 147px !important;
      .el-input {
        width: 147px !important;
      }
    }
  }
  .el-form-item--small.el-form-item {
    margin-bottom: 30px;
  }
  .image-config {
    display: flex;

    .el-form-item__label {
      float: none;
    }

    /deep/.el-form-item__content {
      margin-left: 0 !important;
      .uploadImg-cont {
        display: flex;
        flex-direction: row;
        flex-wrap: wrap;
        .uploader {
          margin-bottom: 30px;
          &:last-child {
            margin-right: 0;
          }
          .uploader-image {
            .el-upload.el-upload--text {
              margin-bottom: 10px;
            }
          }
        }
      }
    }
    &.hide-required {
      .el-form-item__label {
        &::before {
          display: none;
        }
      }
    }
  }
}
.marginTop {
  margin-top: 30px;
}
.addPrize {
  width: 150px;
  height: 34px;
  color: #bbbbbb;
  border: 1px dashed #bbbbbb;
}
.delPrize:hover {
  text-decoration: underline;
}
.lotteryDisabled {
  cursor: not-allowed;
}
.lottery-context {
  pointer-events: none;
}
.lotteryDisabled:hover:after {
  position: absolute;
  margin-left: 48px;
  padding: 2px 10px;
  box-shadow: 0 2px 9px #999;
  background-color: #fff;
  border-radius: 4px;
  color: #666;
  content: attr(title);
  z-index: 2;
  line-height: 20px;
  height: 20px;
}
</style>
